// Full-document render of the stearns FinancePage: PageSkeleton (the React
// document shell) wrapping the existing consolidated finance-page body
// assembly. The legacy template rendered the body island in {% block layout %}
// -- adjacent content inside <main> -- so the document DOM matches the other
// content pages. The six side-channel props (default plan terms,
// richtext-expanded headline, disclosure HTML, hero image URL) are threaded
// through unchanged from the server's get_finance_page_body data.
import React from "react";

import { templates } from "@reactivated";

import { FinancePageBody } from "../components/FinancePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.StearnsFinancePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <FinancePageBody
            page={props.page}
            apr={props.apr}
            term_months={props.term_months}
            fine_print_superscript={props.fine_print_superscript}
            headline_html={props.headline_html}
            terms_html={props.terms_html}
            hero_image_url={props.hero_image_url}
        />
    </PageSkeleton>
);
